import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import {
  authenticatedFetch,
  getAuthenticatedAxiosConfig,
  openAuthenticatedUrl,
} from '../utils/authApi';

export function useAuthFetch() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const authFetch = useCallback(
    (url, options) => authenticatedFetch(instance, account, url, options),
    [instance, account]
  );

  const getAuthConfig = useCallback(
    (config) => getAuthenticatedAxiosConfig(instance, account, config),
    [instance, account]
  );

  const openAuthUrl = useCallback(
    (url) => openAuthenticatedUrl(instance, account, url),
    [instance, account]
  );

  return {
    authFetch,
    getAuthConfig,
    openAuthUrl,
    isReady: Boolean(account),
  };
}
